export const MAX_IMAGE_FILE_SIZE = 10
export const MAX_VIDEO_FILE_SIZE = 50
